import { FdjUsersApiSearchCommand, FdjUsersFilterValues, FdjUsersSortableFields } from './fdjUsersTypes';
import { convertWithDefaultNumber, parseQueryString } from '@eogile/agrements-common/src/utils/queryStringUtils';
import { FdjUserProfile } from '../fdjUserTypes';
import { DEFAULT_PAGE, DEFAULT_PAGE_SIZE, SortOrder } from '@eogile/agrements-common/src/components/table/tableTypes';
import { UserCompany } from '@eogile/agrements-common/src/user/commonTypes';

/**
 * Transform the given query string into valid filter form values.
 */
export function queryStringToFilterValues(search: string): FdjUsersFilterValues {
  const params = parseQueryString(search);
  return {
    login: (params.login as string) ?? null,
    lastName: (params.lastName as string) ?? null,
    email: (params.email as string) ?? null,
    agencyCode: (params.agencyCode as string) ?? null,
    profile: (params.profile as FdjUserProfile) ?? null,
    page: convertWithDefaultNumber(params.page, DEFAULT_PAGE),
    pageSize: convertWithDefaultNumber(params.pageSize, DEFAULT_PAGE_SIZE),
    sortField: (params.sortField as FdjUsersSortableFields) ?? 'LOGIN',
    sortOrder: (params.sortOrder as SortOrder) ?? 'ASC',
  };
}

/**
 * Transform th given filter values into a search command that can
 * be understood by the API.
 */
export function toApiSearchCommand(filterValues: FdjUsersFilterValues): FdjUsersApiSearchCommand {
  return {
    ...filterValues,
    company: UserCompany.FDJ,
  };
}
